module.exports = __webpack_public_path__ + "img/zanorari42.fe161fba.png";